import { render, staticRenderFns } from "./aiscript-info.vue?vue&type=template&id=919ac174&"
import script from "./aiscript-info.vue?vue&type=script&lang=js&"
export * from "./aiscript-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "aiscript-info.vue"
export default component.exports